<template>
    <el-dialog
        title="货站转单"
        top="8%"
        width="30%"
        :before-close="handleClose"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        class="station-transfer-order-dialog"
    >
        <div class="station-transfer-lspTransferStationName">
            运输单当前货站：{{ rowData.lspTransferStationName }}
        </div>
        <el-form
            :model="transferOrderInfoForm"
            :rules="+MIPInfo.accountSign === 1 ?stationRules : supplierRules"
            ref="form"
            label-width="120px"
        >
            <el-row>
                <el-col :span="22">
                    <el-form-item label="货站名称：" prop="inStationName">
                        <el-input
                            v-model="transferOrderInfoForm.inStationName"
                            :readonly="true"
                            autocomplete="off"
                            placeholder="货站名称"
                        >
                            <i
                                slot="suffix"
                                class="el-input__icon el-icon-circle-close"
                                v-if="transferOrderInfoForm.inStationName"
                                @click="clearStationInfo"
                            ></i>
                            <el-button
                                slot="append"
                                icon="el-icon-search"
                                @click="openAdvanceDialog"
                            ></el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="22">
                    <el-form-item label="司机名称：" prop="driverName">
                        <el-input
                            v-model="transferOrderInfoForm.driverName"
                            autocomplete="off"
                            placeholder="司机名称"
                            clearable
                            maxlength = "32"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="22">
                    <el-form-item label="司机电话：" prop="driverMobile">
                        <el-input
                            v-model="transferOrderInfoForm.driverMobile"
                            autocomplete="off"
                            placeholder="司机电话"
                            clearable
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="22">
                    <el-form-item label="车牌号码：" prop="carNo">
                        <el-input
                            v-model="transferOrderInfoForm.carNo"
                            autocomplete="off"
                            placeholder="车牌号码"
                            clearable
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="22">
                    <el-form-item label="货站联系人姓名：" prop="contactsName">
                        <el-input
                            v-model="transferOrderInfoForm.contactsName"
                            autocomplete="off"
                            :disabled="true"
                            placeholder="转入货站联系人姓名"
                            clearable
                            maxlength="32"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="22">
                    <el-form-item
                        label="货站联系人电话："
                        prop="contactsMobile"
                    >
                        <el-input
                            v-model="transferOrderInfoForm.contactsMobile"
                            autocomplete="off"
                            :disabled="true"
                            placeholder="转入货站联系人手机号"
                            clearable
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <el-button type="primary" @click="handleSubmit">提 交</el-button>
            <el-button @click="handleClose">取 消</el-button>
        </template>

        <advanceDialog
            ref="advanceDialog"
            v-model="transferOrderInfoForm.inStationName"
            :mValue="transferOrderInfoForm.inStationName"
            :params="stationConfig"
            @confirm="confirm"
        ></advanceDialog>
    </el-dialog>
</template>

<script>
import advanceDialog from '@/components/lots/otpAdvanceDialog';
import { stationConfig } from './config.js';
import { transferOrderOrAssignDriver } from '../../../../../api/transferSystem.js';
export default {
    name: 'stationTransferOrderDialog',
    components: {
        advanceDialog
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        rowData: {
            type: Array | Object,
            required: true
        },
        batchOperation: {
            type: Boolean,
            default: false
        },
        MIPInfo: {
            type: Object,
            required: true
        },
        consumerCode: { }
    },
    data () {
        // 校验 司机手机号 格式
        var validateDriverPass = (rule, value, callback) => {
            const _phoneVerify = /^1(3|4|5|6|7|8|9)\d{9}$/;
            if (!value) {
                callback(new Error('请输入司机手机号'));
            } else if (!_phoneVerify.test(value)) {
                callback(new Error('请输入正确的司机手机号'));
            } else {
                callback();
            }
        };
        // 校验 车牌号 格式
        var validateCarNoPass = (rule, value, callback) => {
            const _carNoVerify = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]$/;
            if (!value) {
                callback(new Error('请输入车牌号码'));
            } else if (!_carNoVerify.test(value)) {
                callback(new Error('请输入正确的车牌号码'));
            } else {
                callback();
            }
        };
        return {
            stationConfig,
            transferOrderInfoForm: {
                carNo: '',
                driverName: '',
                driverMobile: '',
                inStationName: '',
                inStationCode: '',
                contactsName: '',
                contactsMobile: '',
                required: true
            },
            stationRules: {
                inStationName: [{ required: true, message: '请输入货站平台名称', trigger: ['change', 'blur'] }],
                driverName: [{ required: true, message: '请输入司机名称', trigger: ['change', 'blur'] }],
                driverMobile: [{ validator: validateDriverPass, required: true, trigger: ['change', 'blur'] }],
                carNo: [{ validator: validateCarNoPass, required: true, trigger: ['change', 'blur'] }]
            },
            supplierRules: {
                inStationName: [{ required: true, message: '请输入货站平台名称', trigger: ['change', 'blur'] }]
            },
        }
    },
    methods: {
        // 打开货站高级搜索 弹窗
        openAdvanceDialog () {
            this.$refs.advanceDialog.show(true, this.stationConfig, { supplierCode: this.consumerCode }, '', [], this.transferOrderInfoForm.inStationName);
        },
        // 货站搜索框 清空的方法
        clearStationInfo () {
            this.transferOrderInfoForm.inStationName = '',
            this.transferOrderInfoForm.inStationCode = '',
            this.transferOrderInfoForm.contactsName = '',
            this.transferOrderInfoForm.contactsMobile = ''
        },
        // 货站高级搜索 数据选中的回调
        confirm (data) {
            this.transferOrderInfoForm.inStationName = data.stationName;
            this.transferOrderInfoForm.inStationCode = data.stationCode;
            this.transferOrderInfoForm.contactsName = data.contactsName;
            this.transferOrderInfoForm.contactsMobile = data.contactsMobile;
        },
        // 提交
        handleSubmit () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // 判断是否为 批量操作
                    if (!this.batchOperation) {
                        const param = this.formateSingleSubmitParams();
                        this.submitByApi([param]);
                    } else {
                        const param = this.formateBatchSubmitParams(this.rowData);
                        this.submitByApi(param);
                    }
                } else {
                    return false;
                }
            });
        },
        // 行操作 货站转单 提交时 组装数据
        formateSingleSubmitParams () {
            const data = {
                ...this.rowData,
                inStationName: this.transferOrderInfoForm.inStationName,
                inStationCode: this.transferOrderInfoForm.inStationCode,
                carNo: this.transferOrderInfoForm.carNo,
                driverName: this.transferOrderInfoForm.driverName,
                driverMobile: this.transferOrderInfoForm.driverMobile,
                contactsName: this.transferOrderInfoForm.contactsName,
                contactsMobile: this.transferOrderInfoForm.contactsMobile,
            }
            return data;
        },
        // 批量货站转单 提交时 遍历 并组装参数
        formateBatchSubmitParams (list) {
            list.forEach(item => {
                item.inStationName = this.transferOrderInfoForm.inStationName,
                item.inStationCode = this.transferOrderInfoForm.inStationCode,
                item.carNo = this.transferOrderInfoForm.carNo,
                item.driverName = this.transferOrderInfoForm.driverName,
                item.driverMobile = this.transferOrderInfoForm.driverMobile,
                item.contactsName = this.transferOrderInfoForm.contactsName,
                item.contactsMobile = this.transferOrderInfoForm.contactsMobile
            })
            return list;
        },
        // 提交按钮 调用接口
        submitByApi (params) {
            transferOrderOrAssignDriver(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('转单成功');
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.$emit('handleSuccess', 'transferOrderDialogVisible')
                })
        },
        // 关闭弹窗
        handleClose () {
            this.$emit('handleClose', 'transferOrderDialogVisible');
        }
    }
}
</script>
<style lang="less" scoped>
.station-transfer-order-dialog {
    .station-transfer-lspTransferStationName {
        margin-bottom: 12px;
    }
    .el-dialog__body {
        margin-top: 10px;
    }
    .el-col {
        width: 98%;
    }
    .el-form-item__content .el-input-group {
        vertical-align: middle;
    }
}
</style>
